import { IEmptyReviews } from 'shared/repositories/dailyrent/entities/response/EmptyReviews';

import type { IState } from '../../store';

export const selectEmptyReviews = (state: IState): IEmptyReviews | null => {
  return state.dailyrentData?.emptyReviews || null;
};
